import { IRecuperacaoContasPagarUseCase } from "../../../presentation/useCases/update/recuperacao_contas_pagar_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * RecuperacaoContasPagarUseCase
 */

export class RecuperacaoContasPagarUseCase implements IRecuperacaoContasPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async recuperacaoContasPagar(idsContaPagas: number[]): Promise<void> {
    await this.repository.recuperacaoContasPagar(idsContaPagas);

  }

}
